export default __webpack_public_path__ + "static/media/302-Series-Brass-Regulators.3aafe989.jpg";